import { T } from "@tolgee/react";
import { FC } from "react";
import { Button, ButtonProps } from "../ui/button";

export const BomPageExplainerCloseButton: FC<ButtonProps> = ({ ...props }) => {
  return (
    <Button color="indigo" {...props}>
      <T keyName="pq-bom-t1-product-page-instructions-modal-close-button-text" />
    </Button>
  );
};
